import React from "react"
import { Link } from "gatsby"

const ContentListFooterLinks = () => {
  return (
    <div className="flex justify-center items-center mt-10 -ml-2">
      <Link
        className="border border-1 px-4 py-2 rounded-sm mx-2 hover:bg-brand hover:text-white"
        to="/categories/"
      >
        All Categories
      </Link>
      <Link
        className=" border border-1 px-4 py-2 rounded-sm mx-2 hover:bg-brand hover:text-white"
        to="/tags/"
      >
        All Tags
      </Link>
    </div>
  )
}

export default ContentListFooterLinks
